<template>
  <div id="app">
    <div id="nav">
      <nav id="dashboard-navbar" class="navbar  navbar-expand-lg navbar-light" v-if="!HideNav">
        <div class="navbar-brand">
            <a class="">
                <img src="https://www.cincpro.com/wp-content/uploads/2019/01/CINC-Logo-Footer.png" height="25" class="d-inline-block align-top">
                <span v-cloak>{{Title}}</span>
            </a>
        </div>
        <ul class="navbar-nav pointer mr-auto">
          <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span v-cloak>Helpful Links</span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item pointer" @click="sendToSwagger()"><i class="fas fa-list-ul"></i> Swagger</a>
                <a class="dropdown-item pointer" @click="navigateToRoute('/docs/intro')"><i class="far fa-file-alt"></i> Docs</a>
              </div>
          </li>
        </ul>
        <div class="nav-item pull-right">
          <ul v-if="this.User.isLoggedIn" class="navbar-nav pointer mr-auto">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="userDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span v-cloak style="margin-left:75px;">{{User.firstName}} {{User.lastName}}</span>
              </a>
              <div>
                <div class="dropdown-menu" aria-labelledby="userDropdownMenuLink">
                <a class="dropdown-item pointer" v-bind:href="'http://' + User.domainName" target="_blank"><i class="fa fa-globe"></i> My CINC Site</a>
                <a class="dropdown-item pointer" @click="logout()"><i class="fas fa-sign-out-alt"></i> Logout</a>

                <div class="dropdown-divider"></div>
                <h6 class="dropdown-header">Dashboard</h6>
                <a class="dropdown-item pointer" @click="navigateToRoute('/dashboard')"><i class="fas fa-tachometer-alt"></i> API Dashboard</a>
                <a class="dropdown-item pointer" @click="navigateToRoute('/dashboard/tokens')"><i class="fas fa-key"></i> Tokens</a>

                <div v-if="this.AdminCookie != ''">
                  <div class="dropdown-divider"></div>
                  <h6 class="dropdown-header">Admin</h6>
                  <a class="dropdown-item pointer" @click="navigateToRoute('/dashboard/admin')"><i class="fas fa-user-shield"></i> Admin Dashboard</a>
                  <a class="dropdown-item pointer" @click="navigateToRoute('/dashboard/admin/integrationtests')"><i class="fas fa-tasks"></i> Integration Tests</a>
                  <a class="dropdown-item pointer" @click="navigateToRoute('/dashboard/admin/processes')"><i class="fas fa-microchip"></i> Processes</a>
                </div>
              </div>
              </div>
              
            </li>
          </ul>
          <a v-else class="nav-link pointer" @click="login()">Log In</a>
        </div>
      </nav>
    </div>
    <router-view/>
  </div>
</template>
<style lang="scss">
  @import './style/metis.core.scss';
</style>
<script lang="ts">
import { defineComponent, watch } from 'vue'
import { mapGetters } from "vuex";
import { User } from "./models/User";
import { Config } from "./models/Config";

export default defineComponent({
  name: "App",
  computed: {
    ...mapGetters({
      User: "userstate/getUser",
      AdminCookie: "userstate/getAdminCookie",
    }),
  },
  data() {
    return {
      Title: "API Documentation",
      HideNav: false,
      swaggerUrl: "",
      config: require("../config.json") as Config,
    }
  },
  async beforeMount() {
    this.swaggerUrl = this.config.apiUrl;
    if (this.User && this.User.isLoggedIn && this.AdminCookie) {
      await this.$store.dispatch("createAxiosService", { isAdmin: true, adminCookie: this.AdminCookie });
    }
    else {
      this.$store.dispatch("createAxiosService", { isAdmin: false, adminCookie: "" });
    }
  },
  methods: {
    login() {
      if (!window.location.pathname.includes('/auth/login'))
        this.$router.push({ name: "Login" });
    },
    async logout() {
      this.$store.state.axiosService.Logout()
        .catch((response: any) => {
          console.log("Error logging out.");
        })
        .finally(() => {
          this.$store.dispatch('userstate/setUser', new User("", "", "", false));
          this.$store.dispatch("createAxiosService", { isAdmin: false, adminCookie: "" });
          this.$store.dispatch('userstate/setAdminCookie', "");
          this.navigateToRoute('/docs/intro');
        });
    },

    sendToSwagger() {
      window.open(this.swaggerUrl, '_blank');
    },

    navigateToRoute(routePath: string) {
      this.$router.push({ path: routePath }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
      });
    }
  }
})
</script>
